module.exports = window.$



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/index.js
 ** module id = 169
 ** module chunks = 0 2
 **/